/* 🤖 this file was generated by script */
export const wsolidiconInfoCircle = {
  name: 'info_circle',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 1a11 11 0 1 0 0 22 11 11 0 0 0 0-22m0 6a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2zm1 5a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0z" clip-rule="evenodd"/></svg>`,
  iconStyle: '',
};
